import { SendOutlined } from "@ant-design/icons"
import { App, Button, Typography } from "antd"

import { useApiContext } from "#contexts/ApiContextProvider"

import EmptyPage from "./EmptyPage"
import Flex from "./Flex"
import FormattedTextBlock from "./FormattedTextBlock"

interface ErrorFallbackPageProps {
  error?: Error
  resetError?: () => void
}

const ErrorFallbackPage = ({
  error,
  resetError = () => {
    location.reload()
  },
}: ErrorFallbackPageProps) => {
  const { apiHandler } = useApiContext()
  const { sendErrorToDevs } = apiHandler
  const { message } = App.useApp()

  return (
    <EmptyPage title="Oops! Something went wrong">
      <Flex col style={{ gap: 16 }}>
        <Typography.Text
          style={{
            color: "#8B4513",
            textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
            fontFamily: "Comic Sans MS, cursive, sans-serif",
            fontWeight: "normal",
            lineHeight: "1.4",
            margin: 0,
          }}
        >
          Use the navigation above to go somewhere else, or give me some belly
          rubs while you figure it out!
        </Typography.Text>

        {error && (
          <Flex col gap={16}>
            <Flex
              col
              style={{
                gap: 8,
                backgroundColor: "rgba(0,0,0,0.05)",
                borderRadius: 8,
                padding: 12,
              }}
            >
              Error details:
              <FormattedTextBlock
                text={error.message}
                style={{ fontSize: 12 }}
              />
            </Flex>
            <Flex>
              <Button
                key="sendToDevs"
                onClick={async () => {
                  await sendErrorToDevs(
                    "Error fallback",
                    error.message,
                    "Error fallback"
                  )
                  message.success("Error sent! Thanks for your help!")
                }}
              >
                <SendOutlined />
                Send to devs
              </Button>
            </Flex>
          </Flex>
        )}

        {resetError && (
          <Button
            type="primary"
            size="large"
            onClick={resetError}
            style={{ width: "fit-content" }}
          >
            Try again
          </Button>
        )}
      </Flex>
    </EmptyPage>
  )
}

export default ErrorFallbackPage
